import axios from 'shared/api/axios';
import { TrusthubRegistrationBody } from 'types/outbound';
import { ConfigureA2PPhoneNumberPayload } from '../types';

export const registrationApi = {
  async getProgress() {
    const res = await axios.get('/api/v1/ai-chatbots/inbound-ai-rep/registration/status');
    return res.data;
  },

  async registerBusinessProfile(data: TrusthubRegistrationBody) {
    const res = await axios.post(
      '/api/v1/ai-chatbots/inbound-ai-rep/registration/register-business',
      data,
    );
    return res.data;
  },

  async configureBusinessForA2P() {
    const res = await axios.post(
      `/api/v1/ai-chatbots/inbound-ai-rep/registration/configure-business-for-a2p`,
    );
    return res.data;
  },

  async registerA2pCampaign() {
    const res = await axios.post(
      `/api/v1/ai-chatbots/inbound-ai-rep/registration/register-a2p-campaign`,
    );
    return res.data;
  },

  async configurePhoneNumberForCampaign(data: ConfigureA2PPhoneNumberPayload) {
    const res = await axios.post(
      `/api/v1/ai-chatbots/inbound-ai-rep/phone-number/configure-a2p-campaign`,
      data,
    );
    return res.data;
  },
};
